module.exports = __webpack_public_path__ + "media/images/resource-types/other-c95a0244a482b9725551116627ae57a2.svg";